import styled from "@emotion/styled"

export const StyledBadges = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .form-card,
  .table-card {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    box-shadow: none;
    background: var(--cms-surface-secondary);
  }

  .section-title {
    margin: 0 0 6px;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .section-subtitle {
    margin: 0 0 12px;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 600;
  }

  .form-row {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 10px;
  }

  .icon-row {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }

  .icon-field {
    flex: 1;
    min-width: 280px;
  }

  .icon-preview {
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-muted);
    border-radius: 10px;
    padding: 8px 10px;
  }

  .icon-preview img {
    width: 46px;
    height: 46px;
    object-fit: contain;
    border-radius: 8px;
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-secondary);
  }

  .form-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .form-actions .MuiButton-root,
  .icon-row .MuiButton-root {
    text-transform: none;
    border-radius: 9px;
    min-height: 36px;
    font-weight: 700;
    padding: 5px 12px;
  }

  .table-shell .MuiTableContainer-root {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
  }

  .table-shell .MuiTableCell-head {
    background: var(--cms-table-head-bg);
    color: var(--cms-text-primary);
    font-weight: 700;
    font-size: 12px;
    border-bottom: 1px solid var(--cms-border);
  }

  .table-shell .MuiTableCell-body {
    font-size: 13px;
    color: var(--cms-text-primary);
    border-bottom: 1px solid var(--cms-border);
    vertical-align: top;
  }

  .table-shell a {
    color: var(--cms-link-color);
    text-decoration: none;
    font-weight: 700;
  }

  .table-shell a:hover {
    text-decoration: underline;
  }

  .table-empty {
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    padding: 18px;
  }

  .table-actions {
    display: flex;
    justify-content: flex-end;
    gap: 4px;
  }

  @media (max-width: 940px) {
    .form-row {
      grid-template-columns: minmax(0, 1fr);
    }
  }
`
